var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page"},[_c('HeadBar'),_c('router-view'),_c('el-backtop',{attrs:{"right":400,"bottom":150}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }